/* MCR · Virtual try-on dialog ([data-mcr-tryon]) + the gallery stylist dock ([data-mcr-dock]).
   Flow: photo (live camera or upload) → choose this product or a related one → result.
   When the block's "AI try-on service URL" is set, the photo and garment image are POSTed there as JSON
   { person: <jpeg data URL>, garment: <image URL>, category: tops|bottoms|one-pieces, product: {...} } and the
   service answers { image: <URL or data URL> }. Without a URL the shopper gets a side-by-side preview and a
   WhatsApp stylist opinion, and the photo never leaves the phone. */
(function () {
  'use strict';
  if (window.__mcrTryon) return;
  window.__mcrTryon = true;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents, fmt) {
    var p = ((cents || 0) / 100).toFixed(2).split('.');
    var g = function (n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return String(fmt || '₹{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return g(p[0], ',');
      if (k === 'amount_with_comma_separator') return g(p[0], '.') + ',' + p[1];
      return g(p[0], ',') + '.' + p[1];
    });
  }
  function absUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return u;
  }
  function sized(u, w) {
    if (!u) return '';
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function category(p) {
    var t = ((p.type || '') + ' ' + (p.title || '')).toLowerCase();
    if (/\bset\b|combo|kurta|kurtha/.test(t)) return 'one-pieces';
    if (/dhot|lungi|mundu|veshti|pant|trouser/.test(t)) return 'bottoms';
    return 'tops';
  }

  function TryOn(dlg) {
    this.dlg = dlg;
    this.video = dlg.querySelector('[data-cam-video]');
    this.canvas = dlg.querySelector('[data-tryon-canvas]');
    this.endpoint = (dlg.dataset.endpoint || '').trim();
    this.fmt = dlg.dataset.moneyFormat;
    this.facing = 'user';
    this.results = {};
    try { this.current = JSON.parse(dlg.querySelector('[data-tryon-product]').textContent); } catch (e) { this.current = null; }
    this.items = this.current ? [this.current] : [];
    this.sel = 0;
    var self = this;
    dlg.addEventListener('click', function (e) { self.onClick(e); });
    dlg.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-tryon-upload], [data-tryon-native]');
      if (inp && inp.files && inp.files[0]) self.fromFile(inp.files[0]);
      if (inp) inp.value = '';
    });
    dlg.addEventListener('close', function () {
      self.stop();
      if (self.abort) self.abort.abort();
      document.body.classList.remove('overflow-hidden');
    });
    this.loadRelated();
  }

  TryOn.prototype.show = function (step) {
    this.step = step;
    this.dlg.querySelectorAll('[data-step]').forEach(function (el) { el.hidden = el.dataset.step !== step; });
    this.dlg.classList.toggle('is-camera', step === 'camera');
    this.dlg.classList.toggle('is-result', step === 'result' || step === 'pick' || step === 'loading');
    var box = this.dlg.querySelector('.mcr-match__box');
    if (box) box.scrollTop = 0;
  };

  TryOn.prototype.open = function () {
    this.show(this.photo ? 'pick' : 'start');
    if (this.photo) this.renderList();
    if (!this.dlg.open) this.dlg.showModal();
    document.body.classList.add('overflow-hidden');
  };

  TryOn.prototype.onClick = function (e) {
    var t = e.target;
    if (t === this.dlg || t.closest('[data-tryon-close]')) { this.dlg.close(); return; }
    if (t.closest('[data-tryon-camera]')) { this.camera(); return; }
    if (t.closest('[data-cam-cancel]')) { this.stop(); this.show(this.photo ? 'pick' : 'start'); return; }
    if (t.closest('[data-cam-flip]')) { this.facing = this.facing === 'user' ? 'environment' : 'user'; this.camera(); return; }
    if (t.closest('[data-cam-shoot]')) { this.shoot(); return; }
    if (t.closest('[data-tryon-retake]')) { this.results = {}; this.show('start'); return; }
    if (t.closest('[data-tryon-again]')) { this.show('pick'); this.renderList(); return; }
    if (t.closest('[data-tryon-go]')) { this.go(); return; }
    if (t.closest('[data-tryon-add]')) { this.add(); return; }
    if (t.closest('[data-tryon-share]')) { this.share(); return; }
    var opt = t.closest('[data-tryon-opt]');
    if (opt) {
      this.sel = +opt.dataset.tryonOpt;
      this.dlg.querySelectorAll('[data-tryon-opt]').forEach(function (b) { b.setAttribute('aria-checked', b === opt ? 'true' : 'false'); });
    }
  };

  /* ---------- related pieces to try ---------- */
  TryOn.prototype.loadRelated = function () {
    var self = this, url = this.dlg.dataset.recoUrl;
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        (j.products || []).forEach(function (p) {
          if (!p.available || !p.featured_image || (self.current && p.id === self.current.id)) return;
          self.items.push({ id: p.id, title: p.title, type: p.type, url: p.url, image: absUrl(p.featured_image), price: p.price });
        });
        if (self.step === 'pick') self.renderList();
      })
      .catch(function () {});
  };
  TryOn.prototype.renderList = function () {
    var self = this, list = this.dlg.querySelector('[data-tryon-list]');
    if (this.sel >= this.items.length) this.sel = 0;
    list.innerHTML = this.items.slice(0, 9).map(function (p, i) {
      return '<li><button type="button" role="radio" class="mcr-tryon__opt" data-tryon-opt="' + i + '" aria-checked="' + (i === self.sel) + '">' +
        '<span class="mcr-tryon__opt-img" data-mcr-fit><img src="' + esc(sized(p.image, 300)) + '" alt="" loading="lazy" width="150" height="200"></span>' +
        '<span class="mcr-tryon__opt-name">' + (p.current ? '<em>This piece</em>' : '') + esc(p.title) + '</span>' +
        '<span class="mcr-tryon__opt-price">' + esc(money(p.price, self.fmt)) + '</span>' +
        (self.results[p.id] ? '<span class="mcr-tryon__opt-done">Tried</span>' : '') +
        '</button></li>';
    }).join('');
  };

  /* ---------- photo ---------- */
  TryOn.prototype.camera = function () {
    var self = this;
    this.stop();
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { this.dlg.querySelector('[data-tryon-native]').click(); return; }
    this.show('camera');
    navigator.mediaDevices.getUserMedia({ video: { facingMode: this.facing, width: { ideal: 1440 }, height: { ideal: 1920 } }, audio: false })
      .then(function (stream) {
        self.stream = stream;
        self.video.srcObject = stream;
        self.video.classList.toggle('is-mirror', self.facing === 'user');
        return self.video.play();
      })
      .catch(function () {
        self.show('start');
        self.dlg.querySelector('[data-tryon-native]').click();
      });
  };
  TryOn.prototype.stop = function () {
    if (this.stream) { this.stream.getTracks().forEach(function (t) { t.stop(); }); this.stream = null; }
  };
  TryOn.prototype.shoot = function () {
    var v = this.video;
    if (!v.videoWidth) return;
    var vw = v.videoWidth, vh = v.videoHeight, tw = Math.min(vw, vh * 0.75), th = tw / 0.75;
    var c = this.canvas; c.width = 768; c.height = 1024;
    var ctx = c.getContext('2d');
    ctx.save();
    if (this.facing === 'user') { ctx.translate(c.width, 0); ctx.scale(-1, 1); }
    ctx.drawImage(v, (vw - tw) / 2, (vh - th) / 2, tw, th, 0, 0, c.width, c.height);
    ctx.restore();
    this.stop();
    this.finish();
  };
  TryOn.prototype.fromFile = function (file) {
    var self = this, img = new Image(), url = URL.createObjectURL(file);
    img.onload = function () {
      // keep the whole photo (no crop) — people often upload full-length pictures
      var s = Math.min(1, 1280 / Math.max(img.width, img.height));
      var c = self.canvas; c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      self.finish();
    };
    img.onerror = function () { URL.revokeObjectURL(url); };
    img.src = url;
  };
  TryOn.prototype.finish = function () {
    this.photo = this.canvas.toDataURL('image/jpeg', 0.9);
    this.results = {};
    this.dlg.querySelector('[data-tryon-me]').src = this.photo;
    this.dlg.querySelector('[data-tryon-me-lg]').src = this.photo;
    this.show('pick');
    this.renderList();
  };

  /* ---------- try on ---------- */
  TryOn.prototype.go = function () {
    var p = this.items[this.sel], self = this;
    if (!p || !this.photo) return;
    if (this.results[p.id]) { this.result(p, this.results[p.id]); return; }
    if (!this.endpoint) { this.result(p, null); return; }
    this.show('loading');
    var status = this.dlg.querySelector('[data-tryon-status]');
    var msgs = ['Tailoring your look…', 'Matching the fabric and fall…', 'Adding the finishing touches…'], i = 0;
    status.textContent = msgs[0];
    clearInterval(this.tick);
    this.tick = setInterval(function () { i = Math.min(i + 1, msgs.length - 1); status.textContent = msgs[i]; }, 6000);
    this.abort = 'AbortController' in window ? new AbortController() : null;
    var timer = setTimeout(function () { if (self.abort) self.abort.abort(); }, 120000);
    fetch(this.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        person: this.photo,
        garment: absUrl(sized(p.image, 1200)),
        category: category(p),
        product: { id: p.id, title: p.title, url: absUrl(p.url), type: p.type }
      }),
      signal: this.abort ? this.abort.signal : undefined
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.image) throw new Error(j.error || 'Try-on failed'); return j.image; }); })
      .then(function (img) { self.results[p.id] = img; if (self.dlg.open) self.result(p, img); })
      .catch(function () { if (self.dlg.open) self.result(p, null, true); })
      .finally(function () { clearTimeout(timer); clearInterval(self.tick); });
  };

  TryOn.prototype.result = function (p, img, failed) {
    this.shown = p;
    var d = this.dlg;
    var out = d.querySelector('[data-tryon-out]');
    var ai = !!img;
    out.src = ai ? img : this.photo;
    d.querySelector('[data-tryon-out-cap]').textContent = ai ? p.title : 'You';
    d.querySelector('[data-tryon-pimg]').src = sized(p.image, 600);
    d.querySelector('[data-tryon-pimg]').alt = p.title;
    d.querySelector('[data-tryon-pname]').textContent = p.title;
    d.querySelector('[data-tryon-compare]').classList.toggle('is-ai', ai);
    d.querySelector('[data-tryon-result-eyebrow]').textContent = ai ? 'You, in MCR' : 'Side-by-side preview';
    var note = d.querySelector('[data-tryon-note]');
    note.hidden = ai;
    note.textContent = failed
      ? 'We couldn’t create the try-on just now. Here’s a side-by-side preview — or ask our stylist below.'
      : 'Live AI try-on is coming soon. For now, compare yourself with the piece — our stylist will happily tell you how it suits you.';
    d.querySelector('[data-tryon-add-label]').textContent = p.current ? 'Add to bag' : 'View this piece';
    var share = d.querySelector('[data-tryon-share]');
    if (share) share.hidden = !ai;
    var wa = d.querySelector('[data-tryon-wa]');
    if (wa && d.dataset.wa) {
      var text = (d.dataset.waText || '').replace(this.current ? this.current.title : '\u0000', p.title);
      if (!p.current) text = text.replace(/https?:\/\/\S+/, absUrl(p.url));
      wa.href = 'https://wa.me/' + d.dataset.wa + '?text=' + encodeURIComponent(text);
    }
    this.show('result');
  };

  TryOn.prototype.add = function () {
    var p = this.shown;
    if (!p) return;
    if (!p.current) { window.location.href = p.url; return; }
    var btn = document.querySelector('product-form [type="submit"][name="add"], product-form button[type="submit"]');
    this.dlg.close();
    if (btn && !btn.disabled) btn.click();
    else {
      var form = document.querySelector('product-form');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  TryOn.prototype.share = function () {
    var img = this.results[this.shown && this.shown.id];
    if (!img) return;
    var name = 'mcr-try-on.jpg';
    fetch(img).then(function (r) { return r.blob(); }).then(function (blob) {
      var file = new File([blob], name, { type: blob.type || 'image/jpeg' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) return navigator.share({ files: [file], title: 'My MCR look' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
    }).catch(function () { window.open(img, '_blank', 'noopener'); });
  };

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mcr-tryon-open]');
    if (!open) return;
    var d = document.querySelector('[data-mcr-tryon]');
    if (!d || !d.showModal) return;
    e.preventDefault();
    if (!d.__tryon) d.__tryon = new TryOn(d);
    d.__tryon.open();
  });

  /* ---------- gallery dock: sit on the photo slider on phones; sticky on larger screens (CSS) ---------- */
  function placeDocks() {
    document.querySelectorAll('[data-mcr-dock]').forEach(function (dock) {
      var list = dock.parentElement && dock.parentElement.querySelector('.product__media-list');
      if (!list) return;
      if (window.innerWidth >= 990) { dock.style.removeProperty('--dock-top'); dock.classList.remove('is-row'); return; }
      dock.classList.remove('is-row');
      // centre the rail on the part of the first photo that is on screen: below the header, above the
      // sticky buy bar and clear of the floating WhatsApp / chat buttons
      var rect = list.getBoundingClientRect();
      var h = dock.offsetHeight;
      var bandTop = Math.max(rect.top, 0);
      var bandBottom = Math.min(rect.bottom, window.innerHeight - 170);
      var dr = dock.querySelector('.mcr-dock__pill').getBoundingClientRect();
      document.querySelectorAll('.mcr-ai__wafab, .mcr-ai__launch').forEach(function (f) {
        var fr = f.getBoundingClientRect();
        var sideBySide = fr.right < dr.left || fr.left > dr.right;
        if (fr.width && !sideBySide && fr.top > bandTop + h) bandBottom = Math.min(bandBottom, fr.top - 12);
      });
      var top;
      if (bandBottom - bandTop >= h + 16) {
        top = (bandTop + bandBottom) / 2 - rect.top - h / 2 + list.offsetTop;
        top = Math.min(Math.max(top, list.offsetTop + 12), list.offsetTop + list.offsetHeight - h - 12);
      } else {
        // not enough room for the rail: a horizontal row along the top of the photo
        dock.classList.add('is-row');
        top = list.offsetTop + 12;
      }
      dock.style.setProperty('--dock-top', Math.max(0, top) + 'px');
      dock.classList.add('is-placed');
    });
  }
  var raf;
  function queue() { cancelAnimationFrame(raf); raf = requestAnimationFrame(placeDocks); }
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  document.addEventListener('DOMContentLoaded', function () {
    queue();
    if ('ResizeObserver' in window) {
      document.querySelectorAll('[data-mcr-dock]').forEach(function (dock) {
        var list = dock.parentElement && dock.parentElement.querySelector('.product__media-list');
        if (list) new ResizeObserver(queue).observe(list);
      });
    }
  });
  if (document.readyState !== 'loading') queue();
})();
